<template>
  <div>
    <div class="section section-min-blue ">
      <div class="section-container-for-title logoforapps row d-flex justify-content-center">
        <div class="display-6 text-center text-white d-flex justify-content-center">
          <b>Data Collection</b>
        </div>
        <div class=" row d-flex justify-content-center">
          <search v-on:searchText="searchText"></search>
        </div>
      </div>
    </div>
    <div>
      <div class="section bg-light">
        <div class=" container">
          <div class="button-location">
            <button class="custom-button" :class="{ 'active': currentFilter === 'all' }" @click="applyFilter('all')">All</button>
            <button class="custom-button" :class="{ 'active': currentFilter === 'annotated' }" @click="applyFilter('annotated')">Annotated</button>
          </div>
          <div class="content-wrapper">
            <sidebar v-on:conditionsChange="categoryFilter" :annotatedFilter="currentAnnotatedFilter"></sidebar>
            <div id="gallery" class="archFx solutions gallery-container row p-0 m-0">
              <app-list :products="searchProducts"></app-list>
            </div>
          </div>
        </div>
      </div>
      <footer-build-your-app></footer-build-your-app>
    </div>
  </div>
</template>
<script>
import Banner from "@/components/Banner";
import AppList from "@/components/AppList";
import Sidebar from "@/components/Sidebar";
import FooterBuildYourApp from "@/components/FooterBuildYourApp";
import FooterSubscribe from "@/components/FooterSubscribe";
import Search from "@/components/Search";
import Vuex from "vuex";

export default {
  components: {
    search: Search,
    banner: Banner,
    "app-list": AppList,
    sidebar: Sidebar,
    "footer-build-your-app": FooterBuildYourApp,
    "footer-subscribe": FooterSubscribe
  },
  name: "Home",

  data() {
    return {
      conditions: {},
      currentFilter: 'all',
      currentAnnotatedFilter: { annotated: 'all' },
      filteredProducts: [],
      searchProducts: [],
    };
  },

  computed: {
    ...Vuex.mapGetters(["isAuthenticated"])
  },

  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.query.search !== from.query.search && to.query.search) {
        this.loadMyApps();
      } else {
        this.fetchData().then(products => (this.searchProducts = products));
      }
    },
    searchProducts: function (val) {
      this.$emit('searchText', val);
    }
  },

  created() {
    this.products = [];
    if (this.isAuthenticated && this.$route.query.search === "MyApps") {
      this.loadMyApps();
    } else {
      this.fetchData().then(products => {
        this.products = products;
        this.searchProducts = products;
      });
    }
  },

  methods: {
    ...Vuex.mapActions(["startLoading", "endLoading"]),

    loadMyApps() {
      this.startLoading();
      this.$http
        .get("purchase", { params: { populate: "product" } })
        .then(
          response => {
            // transform into products
            this.searchProducts = response.data
              .map(purchase => {
                return purchase.product;
                // To avoid error when App is no longer in the App Store (Deleted)
              })
              .filter(product => product);
          },
          response => {
            // error callback
            console.log(response);
          }
        )
        .finally(() => {
          this.endLoading();
        });
    },

    searchText(text) {
      if (text) {
        const filteredData = this.searchProducts.filter(product => {
          return product.name.toLowerCase().includes(text.toLowerCase());
        });
        this.searchProducts = filteredData;
      } else {
        this.fetchData().then(products => (this.searchProducts = products));
      }
    },

    categoryFilter(conditions) {
      this.categoriesConditions = conditions;
      this.fetchData({ conditions }).then(
        products => (this.searchProducts = products)
      );
    },

    fetchData(params) {
      this.startLoading();
      params = params || {};
      params.populate = "author";
      return this.$http
        .get("product/public", {
          params: params
        })
        .then(
          response => {
            return response.data;
          },
          err => {
            // error callback
            console.log(err);
          }
        )
        .finally(() => {
          this.endLoading();
        });
    },

    applyFilter(filter) {
      this.currentFilter = filter;

      const conditions = { ...this.categoriesConditions };

      if (filter === 'annotated') {
        conditions.annotated = 'yes';
      } else if (filter === 'all') {
        delete conditions.annotated;
      }

      this.fetchData({ conditions }).then(products => (this.searchProducts = products));
    }
  }
};
</script>
<style>
/*************** Gallery *****************************/
.gallery-container>div {
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 15px;
  padding: 0 20px;
}

.gallery-container.solutions .archFx {
  transition: all 250ms ease-in-out;
}

.gallery-container.solutions .item-header {
  height: 168px;
  padding: 10px;
  /* background-color: rgba(255, 255, 255, 0.8);*/
}

.gallery-container.solutions .item-header h3,
.gallery-container.solutions .item-header p {
  margin: 4;
  padding-bottom: 10px;
}

.gallery-container.solutions .item-content {
  height: 170px;
  background-size: 100%;
  background-position: center;
  min-height: 120px;
  margin: 15px;
  border-radius: 6px;
  /*background-color: #fff;*/
  position: relative;
}

.gallery-container.solutions .archTeaser {
  padding: 0;
  align-items: flex-start;
  height: max-content;
}

.gallery-container.solutions .gallery-item {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  text-decoration: none !important;
  color: inherit;
  transition: all 0.3s ease;
}

.gallery-container.solutions .gallery-item:hover {
  background: linear-gradient(to bottom, #E21919, #E95913);
}

.gallery-container.solutions .gallery-item:hover .archTitle,
.gallery-container.solutions .gallery-item:hover .archTeaser {
  color: #fff;
}

.gallery-container.solutions .item-content {
  overflow: hidden;
  background-color: rgba(23, 32, 57, 1);
}

.gallery-container.solutions .tag {
  position: absolute;
  padding: 1em 5px;
  display: flex;
  flex-wrap: wrap;
}

.gallery-container.solutions .gallery-item:hover .tag {
  display: none;
}

.gallery-container.solutions .tag span {
  background: #00000000;
  border-radius: 15;
  color: #000;
  font-size: 11px;
  text-transform: uppercase;
  line-height: 100%;
  border: 1px solid #9ea3b3;
  text-align: center;
}
.gallery-container.solutions .appCover {
  opacity: 0.25;
  overflow: hidden;
  position: relative;
  filter: grayscale(1);
}

.gallery-container.solutions .appCover.custom {
  width: 120%;
  height: 120%;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-size: cover !important;
  left: -10%;
}

.gallery-container.solutions .gallery-item:hover .appCover {
  opacity: 1;
  filter: grayscale(0) blur(0);
  transform: initial;
}

.gallery-container.solutions .gallery-item:hover .custom {
  width: 150%;
  height: 130%;
  top: 0%;
  bottom: -15%;
  left: -25%;
}

.gallery-container.solutions .item-header {
  height: 168px;
  padding: 20px;
  /* background-color: rgba(255, 255, 255, 0.8);*/
}

.tag span {
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  padding: 0.6em 1em;
  border-radius: 1.5em;
  color: #000;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 100%;
}


.custom-button {
  background-color: transparent;
  border: 1px solid #9ea3b3;
  color: #121415;
  padding: 5px 20px;
  font-size: 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease;
  margin-right: 6px;
}

.custom-button:hover,
.custom-button.active {
  background: #E95913;
  color: #fff;
  border-color: #E95913;
}

.button-location {
  margin-left: 15px;
}

.content-wrapper {
  margin: 20px 15px;
  padding: 20px;
  border: 1px solid #9ea3b3;
  border-radius: 6px;

  position: relative;
}

.logo-container {
  display: flex;
  position: relative;
  justify-content: center;
}

.logoforapps {
  background-image: url("../../assets/logoforapps.svg");
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.section-container-custom {
  padding: 2.6875rem 0 0;
}


@media (max-width: 768px) {
  .gallery-container>div {
    display: grid;
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    position: relative;
  }

  .content-wrapper {
    position: relative;
  }
}

@media (min-width: 768px) and (max-width: 1268px) {
  .gallery-container>div {
    display: grid;
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    position: relative;
  }
}

.section-min-blue {
  background: linear-gradient(to bottom, #E21919, #E95913);
  height: 155px;
  padding: 0px 150px;
}

.section .section-container-for-title {
  position: relative;
  height: 165px;
  padding: 22px;
}

.section-py5 {
  position: relative;
  padding: 4rem 0;
}
.fa-circle:before {
  content: none !important;
}

.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>
<style scoped>
@media (min-width: 1200px) {
  .container {
    min-width: 1200px;
  }
}

@media (max-width: 992px) {
  .section .section-container-for-title {
    position: relative;
    height: 155px;
    margin-top: -35px;
    padding: 25px;
  }
}

@media (max-width: 991.98px) {
  .section-min-blue {
    padding: 35px 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/public/Home.vue